'use strict';
var chairsJSON;
var chairsActiveList = [];
var ChairBase = {};

ChairBase.prototype = {
    get title() {
        return this._title;
    },
    get detailsFilename() {

        var filename = this._title.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '') + '.json';

        return filename;
    },
    get distance() {
        return this._distance;
    },
    get qualified() {
        return this._qualified;
    },

    getDistanceFromAttribute: function(attributeName, matchValue) {
        var reply;
        var failedSpecialRule = false;

        var attr = this.attributes[attributeName];
        // if (typeof attr === 'undefined') {
        //     debugger;
        // }
        if (typeof attr === 'number') {
            //no special rules, do a straight difference test
            reply = Math.abs(attr - matchValue);
        } else {
            //special rules have been detected. Check for each known rule.
            var disqualifiedText = '';

            //check if the minimum attribute of the chair is too high for the matchValue
            if ((typeof attr.min !== 'undefined') && (matchValue < attr.min)) {
                failedSpecialRule = true;
                disqualifiedText += ' / min of ' + attr.min + ' more than ideal of ' + matchValue;
            }

            //check if the maximum attribute of the chair is too low for the matchValue
            if ((typeof attr.max !== 'undefined') && (matchValue > attr.max)) {
                failedSpecialRule = true;
                disqualifiedText += ' / max of ' + attr.max + ' less than ideal of ' + matchValue;
            }

            //If this attribute of the chair requires an exact match, test that.
            if ((attr.exact === true) && (matchValue !== attr.ideal)) {
                failedSpecialRule = true;
                disqualifiedText += ' /chair requires exact match of' + attr.ideal + ', compared to ideal ' + matchValue;
            }

            if (failedSpecialRule === true) {

                // console.group('Chair ' + this.title + ' disqualified for ' + attributeName);
                // console.log(disqualifiedText);
                // console.groupEnd();
                reply = false;
            } else {
                //if it is just a range without an ideal score, if it is in the range set
                //distance to 0. I.e., x < 10, 2 > x > 5, x > 2, etc

                if (typeof attr.ideal !== 'undefined') {
                    //there is no ideal value. Since it passed the min-max
                    reply = Math.abs(attr.ideal - matchValue);

                } else {
                    //if there are special conditions and this chair has passed them, 
                    //and there is no ideal score, then give it a score of 0 (which is closest)
                    reply = 0;
                }

            }

        }

        return reply;
    },

    setDistance: function(idealChairAttributes) {
        //determine the total distance of this chair from the ideal chair,
        //including disqualified status. 

        this._distance = 0;
        this._qualified = true;

        for (var attribute in idealChairAttributes) {

            if (idealChairAttributes.hasOwnProperty(attribute)) {

                var matchValue = idealChairAttributes[attribute];
                var addDistance = 0;

                if (matchValue === null) {
                    //this value has not yet been set on the ideal chair. Default
                    //distance to 0 for this one.
                    addDistance = 0;
                } else {
                    var testDistanceResponse = this.getDistanceFromAttribute(attribute, matchValue);

                    if (testDistanceResponse !== false) {
                        addDistance = testDistanceResponse;
                    } else {
                        this._qualified = false;
                        this._distance = 999;
                    }
                }

                this._distance += addDistance;
            } else {
            }
        }


    }
};

function makeChairDatum(chairJSON) {
    var chair = Object.create(ChairBase.prototype, {
        _title: {
            value: chairJSON.title
        },
        _exclude: {
            value: chairJSON.exclude_from_results
        },
        _qualified: {
            value: true,
            writable: true
        },
        attributes: {
            value: {
                adjustability: chairJSON.attributes.adjustability,
                backsupport: chairJSON.attributes.backsupport,
                breathability: chairJSON.attributes.breathability,
                sit_duration: chairJSON.attributes.sit_duration,
                seat_height: chairJSON.attributes.seat_height,
                weight: chairJSON.attributes.weight,
                height_accomodation: chairJSON.attributes.height_accomodation,
                price: chairJSON.attributes.price,
                height_adjust: chairJSON.attributes.height_adjust,
                castors: chairJSON.attributes.castors,
                color_variety: chairJSON.attributes.color_variety,

                mobility: chairJSON.attributes.mobility,
                balanced_recline: chairJSON.attributes.balanced_recline,
            }
        }
    });


    return chair;
}



function makeIdealChair() {
    var attributesRecord;

    function resetAttributes() {
        attributesRecord = {
            adjustability: [],
            backsupport: [],
            breathability: [],
            sit_duration: [],
            seat_height: [],
            weight: [],
            height_accomodation: [],
            price: [],
            height_adjust: [],
            castors: [],
            color_variety: [],
            mobility: [],
            balanced_recline: [],
        };
    }

    function average(array) {

        if (array.length) {

            var sum = 0;
            array.forEach(function (number) {
                sum += number;
            });

            var avg = Math.round(sum / array.length);

            return avg;
        } else {
            return null;
        }
    }

    function calculateIdealAttributes() {
        var idealAttributes = {};
        for (var attr in attributesRecord) {
            if (attributesRecord.hasOwnProperty(attr)) {
                idealAttributes[attr] = average(attributesRecord[attr]);
            }
        }
        return idealAttributes;
    }


    resetAttributes();

    var idealChair = {
        id: 'Chair to Compare',
        get attributes() {
            var idealAttributes = calculateIdealAttributes();
            

            return idealAttributes;
        },

        setAttr: function (attr, val) {
            if (attributesRecord.hasOwnProperty(attr)) {
                attributesRecord[attr].push(val);
            } else {
                console.log('attempted to set attribute ' + attr +', which idealChair does not have');
            }
        },

        reset: function reset() {
            resetAttributes();
        }
    };

    return idealChair;
}
var idealChair = makeIdealChair();

var api = {
    setData: function(data) {
        chairsJSON = data;
        chairsActiveList = [];

        //take the imported raw json and transform them into smarter objects
        chairsJSON.forEach(function(chairJSON) {
            var chair = makeChairDatum(chairJSON);
            
            if (chair._exclude === 'no') {
                chairsActiveList.push(chair);
            }

        });

    },
    getLongNames: function () {
        var one = chairsActiveList.filter(function(item) {
            return item.title === 'Eames Aluminum Group Exec';
        });
        var two = chairsActiveList.filter(function(item) {
            return item.title === 'Eames Aluminum Group Mgmt';
        });
        var three = chairsActiveList.filter(function(item) {
            return item.title === 'Caper Multipurpose Chair';
        });
        // console.log(one, two, three);

        return [one[0], two[0], three[0]];
    },
    getDemo: function () {
        var one = chairsActiveList.filter(function(item) {
            return item.title === 'Setu Stool';
        });
        var two = chairsActiveList.filter(function(item) {
            return item.title === 'Sayl Stool';
        });
        var three = chairsActiveList.filter(function(item) {
            return item.title === 'Caper Multipurpose Chair';
        });
        // console.log(one, two, three);

        return [one[0], two[0], three[0]];
    },
    getAll: function () {
        return chairsActiveList;
    },
    getTop: function(numberOfChairs) {
        api.orderList();

        return chairsActiveList.slice(0, numberOfChairs);
    },
    resetIdealChair: function() {
        idealChair.reset();
    },
    orderList: function() {

        chairsActiveList.forEach(function(chair) {
            chair.setDistance(idealChair.attributes);
        });

        chairsActiveList.sort(function(a, b) {
            return a.distance - b.distance;
        });

        // console.group('Chairs List Ordered');
        // chairsActiveList.forEach(function(chair, index) {
        //     console.log(index, chair.distance, chair.title);
        // });
        // console.groupEnd();

    },
    /**
     * return array of chairs that have not been disqualified
     * @return {Array} [description]
     */
    get qualifiedList() {
        var qualifiedList = chairsActiveList.filter(function(chair) {
            return chair.qualified;
        });
        return qualifiedList;
    },

    get ideal() {
        return idealChair.attributes;
    },
    get list() {
        return chairsActiveList;
    },

    updateIdeal: function(attr, value) {
        idealChair.setAttr(attr, value);


        return idealChair;
    }

};

module.exports = api;